import dayjs from 'dayjs';
import { t } from 'i18next';

import { WeekEnumEng } from 'segments/utils/constants/common';
import { dateToFullFormat, dateToShortFormat, dateToShortHours } from 'segments/utils/helpers/date';
import { shortName } from 'segments/utils/helpers/shortName';

import { CreateCourtBookingServer, CreateCourtBooking, CourtBooking, AddUserToCourtBookingParams, AddUserToCourtBookingParamsServer } from './../store/types';
import { bookingType } from './const';

//transformCreateCourtBookingBody
export const transformCtCourtBkBody = (body: CreateCourtBooking): CreateCourtBookingServer => ({
  'start_time': body.startTime,
  'end_time': body.endTime,
  'court_id': body.courtId,
  ...(body.coachId !== undefined && { 'coach_id': body.coachId }),
  ...(body.extraOptions !== undefined && { 'extra_options': body.extraOptions }),
  ...(body.bookingType !== undefined && { 'booking_type': body.bookingType }),
  ...(body.userId !== undefined && { 'user_id': body.userId }),
  ...(body.repeatUntil !== undefined && { 'repeat_until': body.repeatUntil }),
  ...(body.note !== undefined && { note: body.note }),
  ...(body.customCourtPrice !== undefined && { 'custom_court_price': body.customCourtPrice }),
  ...(body.customCoachPrice !== undefined && { 'custom_coach_price': body.customCoachPrice }),
  ...(body.groupeId !== undefined && { 'group_id': body.groupeId }),
});

//transformAddUserCourtBookingBody
export const transformAUCourtBkBody = (body: Omit<AddUserToCourtBookingParams, 'bookingId'>): AddUserToCourtBookingParamsServer => ({
  'user_id': body.userId,
  ...(body.coachId !== undefined && { 'coach_id': body.coachId }),
  ...(body.extraOptions !== undefined && { 'extra_options': body.extraOptions }),
  ...(body.bookingType !== undefined && { 'booking_type': body.bookingType }),
  ...(body.note !== undefined && { note: body.note }),
  ...(body.customCourtPrice !== undefined && { 'custom_court_price': body.customCourtPrice }),
  ...(body.customCoachPrice !== undefined && { 'custom_coach_price': body.customCoachPrice }),
});

//transformBookedCourtToStats
export const transformBkCourtToStats = ({
  startTime,
  endTime,
  userNames,
  userIds,
  type,
  courtId,
  note,
  created,
  coachNames,
  groupeName
}: CourtBooking): Record<string, string | number> => {
  const filteredCoachName = coachNames.filter((coachName) => coachName !== null) as string[];
  const filteredUserName = userNames.filter((name) => name !== null) as string[];
  const filteredUserIds = userIds.filter((id) => id !== null && id !== undefined) as number[];
  const bookingTypeTittlee = bookingType[type];
  return (
    {
      'booking-time': `${dateToShortHours(startTime)}-${dateToShortHours(endTime)}`,
      'booking-day': `${dateToShortFormat(startTime)} (${t(`weekday.${WeekEnumEng[dayjs(startTime).day()]}`)})`,
      'court': courtId,
      'create-time': dateToFullFormat(created),
      ...(filteredUserName.length !== 0 && { 'user-names': filteredUserName.map((name) => shortName(name)).join(', ') }),
      ...(groupeName !== null && { 'groupe': groupeName }),
      ...(filteredUserIds.length !== 0 && { 'users-id': filteredUserIds.join(', ') }),
      ...(filteredCoachName.length !== 0 && { 'coaches': filteredCoachName.map((coachName) => shortName(coachName)).join(', ') }),
      ...(note && { 'note': note }),
      'booking-type': t(`form-items.select.booking-type.${bookingTypeTittlee}`),
      // 'deposite': confirmed ? t('booked-court.available.deposite') : t('booked-court.not-available.deposite')
    }
  );
};
